import { useState, useEffect } from "react";
import api from "services/api";
import { useRouter } from "hooks";
import * as sessionService from "services/sessionService";
import { ISession } from "config/interfaces";
import { toast } from "react-toastify";
import { getSubDomain, verAccessType } from 'components/shared/getUrl';

interface LoginProps {
  login: string;
  password: string;
  keep: boolean;
}

interface UpdatePassword {
  old_password: string;
  password: string;
}

export default function useAuth() {
  const [user, setUser] = useState<ISession.User | null>(null);
  const [logout, setLogout] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onSuccess, setOnSuccess] = useState(false);
  // const [perfil, setPerfil] = useState("0");
  const [token, setToken] = useState<string | null>(() => {
    const storageToken = localStorage.getItem(
      "@adminModulockerCondominio:token"
    );
    if (storageToken) return storageToken;
    return null;
  });
  const [errorMessage, setErrorMessage] = useState("");
  const router = useRouter();

  // async function getRoles() {
  //   try {
  //     const resp = await api.get("/api_front/UserLoginSearch");
  //     setPerfil(resp.data.PERFIL);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }

  useEffect(() => {
    setLoading(true);
    // getRoles();
    const storageToken = localStorage.getItem(
      "@adminModulockerCondominio:token"
    );
    const storageUser = localStorage.getItem("@adminModulockerCondominio:user");
    if (storageToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(
        storageToken
      )}`;
      setToken(JSON.parse(storageToken));
    }

    if (storageUser) {
      setUser(JSON.parse(storageUser));
    }

    setLoading(false);
  }, []);

  const formatName = (name: string) => {
    const splited = name.includes("@") as any;
    let edited = "";
    if (splited) {
      edited = splited[0].split(".").join(" ");
    } else {
      edited = name.split(".")?.join(" ");
    }
    return edited;
  };

  function signIn(values: LoginProps) {
    setLoading(true);
    localStorage.clear();
    // localStorage.setItem('IDSITE', '');
    // localStorage.setItem('IDMCM', '');
    delete api.defaults.headers?.common?.Authorization;
    const data = {
      email: values.login,
      password: values.password,
    };

    // Habilitar quando usar a API
    sessionService
      .create(data)
      .then((res) => {
        const {
          data: { token: newToken },
        } = res;
        setToken(newToken);

        localStorage.setItem(
          "@adminModulockerCondominio:token",
          JSON.stringify(newToken)
        );

        api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
        setErrorMessage("");

        localStorage.setItem(
          "@adminModulockerCond:user",
          JSON.stringify({ name: formatName(values.login) })
        );

        // verifica o subdominio e redireciona para a tela inicial
        const handleURL = verAccessType(getSubDomain) ? "/correios" : "/home"
        router.push(handleURL);
      })
      .catch((error) => {
        toast.error("Email, celular e/ou senha inválidos.");
        // setErrorMessage(error?.response?.data?.message || "Unknown error");
      })
      .finally(() => setLoading(false));
  }

  function signOut() {
    setLogout(true);
    delete api.defaults.headers?.common?.Authorization;
    setToken(null);
    localStorage.clear();
    router.push("/admin");
  }

  async function updatePassword(values: UpdatePassword) {
    setLoading(true);
    try {
      await sessionService.updatePassword(values);
      setOnSuccess(true);
      setErrorMessage("");
    } catch (error) {
      const err = error as any;
      setErrorMessage(err?.response?.data?.message || "Unknown error");
      // setErrorMessage(error?.response?.data?.message || 'Unknown error');
      setOnSuccess(false);
    } finally {
      setLoading(false);
    }
  }

  async function forgetPassword(email: string) {
    setLoading(true);
    try {
      await sessionService.forgetPassword(email);
      setOnSuccess(true);
      setErrorMessage("");
    } catch (error) {
      const err = error as any;
      setErrorMessage(err?.response?.data?.message || "Unknown error");
      // setErrorMessage(error?.response?.data?.message || 'Unknown error');
      setOnSuccess(false);
    } finally {
      setLoading(false);
    }
  }

  interface ResetPasswordProps {
    token: string;
    password: string;
    password_confirmation: string;
  }
  async function resetPassword(values: ResetPasswordProps) {
    setLoading(true);
    setOnSuccess(false);
    try {
      const { status } = await sessionService.resetPassword(values);
      if (status === 204) {
        setOnSuccess(true);
        setErrorMessage("");
      }
    } catch (error) {
      const err = error as any;
      setErrorMessage(err?.response?.data?.message || "Unknown error");
      // setErrorMessage(error?.response?.data?.message || 'Unknown error');
      setOnSuccess(false);
    }
  }

  return {
    logout,
    setLogout,
    user,
    loading,
    token,
    signIn,
    signOut,
    errorMessage,
    onSuccess,
    setOnSuccess,
    updatePassword,
    forgetPassword,
    isAuthenticated: !!token,
    resetPassword,
  };
}

// fiz alterações nos catch devido ao update do typescript pedir tipos
